const t = (t, n) => {
  const o = !t || t.length <= 0;
  return o || n ? o && n ? "text-only" : !o && n ? "text-icon" : "_" : "icon-only";
};
export { t as g };
